"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeFooterIndexHistoryItem = exports.ChangeHeaderIndexHistoryItem = exports.ChangeHeaderFooterIndexHistoryItemBase = void 0;
var tslib_1 = require("tslib");
var history_item_1 = require("../base/history-item");
var ChangeHeaderFooterIndexHistoryItemBase = (function (_super) {
    tslib_1.__extends(ChangeHeaderFooterIndexHistoryItemBase, _super);
    function ChangeHeaderFooterIndexHistoryItemBase(modelManipulator, sectionIndex, type, newIndex, actionAfterUndo) {
        var _this = _super.call(this, modelManipulator) || this;
        _this.sectionIndex = sectionIndex;
        _this.type = type;
        _this.newIndex = newIndex;
        _this.actionAfterUndo = actionAfterUndo;
        return _this;
    }
    ChangeHeaderFooterIndexHistoryItemBase.prototype.redo = function () {
        this.oldIndex = this.getManipulator().changeObjectIndex(this.sectionIndex, this.type, this.newIndex);
    };
    ChangeHeaderFooterIndexHistoryItemBase.prototype.undo = function () {
        this.getManipulator().changeObjectIndex(this.sectionIndex, this.type, this.oldIndex);
        this.actionAfterUndo(this.oldIndex);
    };
    return ChangeHeaderFooterIndexHistoryItemBase;
}(history_item_1.HistoryItem));
exports.ChangeHeaderFooterIndexHistoryItemBase = ChangeHeaderFooterIndexHistoryItemBase;
var ChangeHeaderIndexHistoryItem = (function (_super) {
    tslib_1.__extends(ChangeHeaderIndexHistoryItem, _super);
    function ChangeHeaderIndexHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeHeaderIndexHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.header;
    };
    return ChangeHeaderIndexHistoryItem;
}(ChangeHeaderFooterIndexHistoryItemBase));
exports.ChangeHeaderIndexHistoryItem = ChangeHeaderIndexHistoryItem;
var ChangeFooterIndexHistoryItem = (function (_super) {
    tslib_1.__extends(ChangeFooterIndexHistoryItem, _super);
    function ChangeFooterIndexHistoryItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChangeFooterIndexHistoryItem.prototype.getManipulator = function () {
        return this.modelManipulator.footer;
    };
    return ChangeFooterIndexHistoryItem;
}(ChangeHeaderFooterIndexHistoryItemBase));
exports.ChangeFooterIndexHistoryItem = ChangeFooterIndexHistoryItem;
